import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import ShiftRepository from "../../repositories/ShiftRepository";

interface _Props {
    shiftRepository: ShiftRepository;
}

@injectable()
export default class DeleteShiftUseCase {
    private shiftRepository: ShiftRepository;
    
    constructor(props: _Props) {
        this.shiftRepository = props.shiftRepository;
    }
    
    public call = async (id: string) : Promise<Either<ErrorEntity, void>> => {
        return this.shiftRepository.deleteShift(id);
    }
}

export const DeleteShiftUseCaseName = "DeleteShiftUseCase";